import axios from "axios";

const TEST_PREFIX = "(TEST) ";
const FLOW_API_TEST_URI = 'https://testflow.rueden.de/api/add/lead/general';
const FLOW_API_URI = 'https://flow.rueden.de/api/add/lead/general';

export default {
    mounted() {
        if (this.$global.showAllInputError == null) this.$global.showAllInputError = false;
        if (this.$global.errorCount == null) this.$global.errorCount = 0;
    },
    methods: {
        sendGaEvent(action=null, label = null) {
            let devPrefix = "";
            if (process.env.VUE_APP_ENV !== "prod") devPrefix = TEST_PREFIX;

            if (typeof action === "string") {
                action = "Frage beantwortet: " + action;
            } else if (typeof action === "number"){
                action = "Weiter zu Schritt " + action;
            }
            // else {
            //     action = "Formular abgeschickt";
            // }

            this.$gtag.event(action, {
                'event_category': devPrefix + this.$global.gaCat,
                'event_label': label
            });
            console.log(devPrefix + this.$global.gaCat, action, label);
        },
        validateForm() {
            if (this.$global.errorCount <= 0) {
                return true;
            } else {
                this.$global = {'gaCat': this.$global.gaCat, 'errorCount' : this.$global.errorCount, 'showAllInputError': true, 'countries': this.$global.countries};
                return false;
            }
        },
        changeErrorCount(more) {
            if (more) {
                this.$global.errorCount = this.$global.errorCount+1;
            } else {
                this.$global.errorCount = this.$global.errorCount-1;
                if (this.$global.errorCount <= 0) {
                    this.$global.showAllInputError = false;
                }
            }
            console.log(this.$global.errorCount);
            this.$global = {'gaCat': this.$global.gaCat, 'errorCount' : this.$global.errorCount, 'showAllInputError': this.$global.showAllInputError, 'countries': this.$global.countries};
        },
        submitToFlowGeneral(stammdaten, referat, falldaten) {
            this.sendGaEvent();
            let data = {
                'stammdaten': this.clearObjectforSerialize(stammdaten),
                'referat': referat,
                'falldaten': falldaten
            };
            data = this.toPlainTextParam(this.removeEmpty(data));
            let uri = FLOW_API_TEST_URI
            if (process.env.VUE_APP_ENV === "prod") uri = FLOW_API_URI;
            axios.post(
                uri,
                data
            ).then(response => {
                return response.status != 200 || response.data[0] != 200
            }).catch(err => {
                console.log(err);
                return true;
            });
        },
        clearObjectforSerialize(data) {
            let r = {};
            for (let prop in data) {
                if (typeof data[prop] === 'object') {
                    let subR = this.clearObjectforSerialize(data[prop]);
                    r = {...r,...subR};
                } else {
                    r[prop] = data[prop];
                }
            }
            return r;
        },
        removeEmpty(data) {
            let r = {};
            for (let prop in data) {
                if (data[prop] && typeof data[prop] === 'object') {
                    let subR = this.removeEmpty(data[prop]);
                    if (Object.keys(subR).length !== 0) r[prop] = subR;
                } else if (data[prop]) {
                    r[prop] = data[prop];
                }
            }
            return r;
        },
        isFirma(str) {
            return ['Einzelunternehmen', 'GmbH', 'UG', 'GmbH & Co. KG', 'GbR', 'AG', 'e.V.', 'OHG'].includes(str)
        },
        toPlainTextParam(data, prev=[]) {
            let r = '';
            let pre = '';
            let isSub = false;
            for (let p of prev) {
                if (!isSub) {
                    pre = p;
                    isSub = true;
                } else {
                    pre += "["+p+"]";
                }
            }
            for (let k of Object.keys(data)) {
                if (typeof data[k] === 'object') {
                    r += this.toPlainTextParam(data[k],prev.concat([k]));
                } else {
                    if (isSub) {
                        r += pre+"["+k+"]="+data[k]+"&";
                    } else {
                        r += pre+k+"="+data[k]+"&";
                    }
                }
            }
            return r;
        }
    }
};